module.exports = __webpack_public_path__ + "img/20220423_162523.ea4492ef.jpg";